import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  Tabs,
  Card,
  Row,
  Col,
  Select,
  Input,
  DatePicker,
  InputNumber,
  Table,
  Button,
  Tag,
} from "antd";
import moment from "moment";
import dayjs from "dayjs";
import { GestionPretsService } from "../../Services/GestionPretsService";
import { CheckCircleOutlined, StopOutlined } from "@ant-design/icons";
import { JournalCentralService } from "../../Services/JournalCentralService";
const { Option } = Select;
const { TabPane } = Tabs;

const NouveauPretsModal = ({
  isVisible,
  onClose,
  employee,
  salaries,
  typePrets,
  rubriques,
  compteGenData,
  form,
}) => {
  const [activeTabKey, setActiveTabKey] = useState("1");
  const [isNextButtonDisabledTab1, setIsNextButtonDisabledTab1] =
    useState(true);
  const [isNextButtonDisabledTab2, setIsNextButtonDisabledTab2] =
    useState(true);

  const [periodiciteOptions, setPeriodiciteOptions] = useState([
    { value: 1, label: "Mensuelle" },
  ]);
  const [pageSize, setPageSize] = useState(5)
  const [echeances, setEcheances] = useState([]);

  const gestionPretsService = new GestionPretsService();
  const journalCentralService = new JournalCentralService();

  const handleDuréeChange = (value) => {
    if (!value) {
      setPeriodiciteOptions([]);
    } else if (value <= 2) {
      setPeriodiciteOptions([{ value: 1, label: "Mensuelle" }]);
      form.setFieldsValue({ periodicite: 1 }); // Réinitialiser à "Mensuelle" si la durée est inférieure ou égale à 2
    } else if (value >= 3) {
      setPeriodiciteOptions([
        { value: 1, label: "Mensuelle" },
        { value: 3, label: "Trimestrielle" },
      ]);
    }
  };

  const handleClose = () => {
    setActiveTabKey("1");
    setEcheances([]);
    if (onClose) {
      onClose();
    }
  };

  useEffect(() => {
    if (employee) {
      const fieldsValue = {
        ...employee,
        date_pret: employee.date_pret ? moment(employee.date_pret) : null,
        date_prem_ech: employee.date_prem_ech
          ? moment(employee.date_prem_ech)
          : null,
        periodicite: 1, // Définir "Mensuelle" par défaut
      };
      form.setFieldsValue(fieldsValue);
      if (employee.listEcheance) {
        setEcheances(employee.listEcheance); // Utiliser listEcheance lors de la modification
      }
    } else {
      form.resetFields();
      form.setFieldsValue({ periodicite: 1 }); // Définir "Mensuelle" par défaut
    }
  }, [employee, form]);

  const handleTabChange = (key) => {
    setActiveTabKey(key);
  };

  const handleEcheances = async () => {
    const formData = form.getFieldsValue();
    try {
      const echeanceData = await gestionPretsService.updateEcheance(formData);
      setEcheances(echeanceData);
    } catch (error) {
      console.error("Erreur lors de la récupération des échéances :", error);
    }
  };

  const handleSave = async () => {
    const formData = form.getFieldsValue();
    const payload = {
      ...formData,
      listEcheance: echeances,
    };

    try {
      if (employee) {
        await gestionPretsService.updatePret(payload);
      } else {
        await gestionPretsService.addEcheance(payload);
      }
      console.log("Enregistrement réussi");
      // onClose();
      handleClose();
    } catch (error) {
      console.error("Erreur lors de l'enregistrement du prêt :", error);
    }
  };

  const formatNumberSeparator = (number) => {
    return number.toLocaleString(); // Utilisez cette fonction pour formater les nombres
  };

  const columns = [
    {
      title: "Numéro",
      dataIndex: "numero",
      key: "numero",
      render: (text) => <div style={{ paddingLeft: 15 }}>{text}</div>,
    },
    {
      title: "Date de remboursement",
      dataIndex: "date_remb",
      key: "date_remb",
      render: (date) => (
        <div style={{ paddingLeft: 15 }}>
          {moment(date).format("D MMMM YYYY")}
        </div>
      ),
    },
    {
      title: "Capital dû",
      dataIndex: "capital_du",
      key: "capital_du",
      align: "right",
      render: (text) => (
        <div style={{ paddingRight: 10 }}>
          {formatNumberSeparator(parseFloat(text))}
        </div>
      ),
    },
    {
      title: "Capital Amorti",
      dataIndex: "capital_amorti",
      key: "capital_amorti",
      align: "right",
      render: (text) => (
        <div style={{ paddingRight: 10 }}>
          {formatNumberSeparator(parseFloat(text))}
        </div>
      ),
    },
    {
      title: "Capital Restant",
      dataIndex: "capital_restant",
      key: "capital_restant",
      align: "right",
      render: (text) => (
        <div style={{ paddingRight: 10 }}>
          {formatNumberSeparator(parseFloat(text))}
        </div>
      ),
    },
    employee && {
      title: "Soldé",
      dataIndex: "solde",
      key: "solde",
      align: "center",
      render: (text) => {
        return text === "oui" ? (
          <CheckCircleOutlined style={{ color: "green" }} />
        ) : (
          <StopOutlined style={{ color: "red" }} />
        );
      },
    },
  ].filter(Boolean);

  useEffect(() => {
    const allValues = form.getFieldsValue();

    const isCompleteTab1 =
      allValues.code_type &&
      allValues.objet_pret &&
      //  allValues.num_decision &&
      allValues.matrisal;
    //  allValues.date_pret;

    const isCompleteTab2 =
      allValues.montant_pret &&
      allValues.duree_pret &&
      allValues.code_rub &&
      allValues.montant_ech &&
      allValues.date_prem_ech &&
      allValues.compte;

    if (employee) {
      setIsNextButtonDisabledTab1(false);
      setIsNextButtonDisabledTab2(false);
    } else {
      setIsNextButtonDisabledTab1(!isCompleteTab1);
      setIsNextButtonDisabledTab2(!isCompleteTab2);
    }
  }, [form.getFieldsValue(), employee]);

  return (
    <Modal
      onCancel={handleClose}
      maskClosable={false}
      title={
        employee && Object.keys(employee).length > 0
          ? `Prêt N° ${employee.code}`
          : "Nouveau Prêt"
      }
      open={isVisible}
      footer={[
        <Button
          key="back"
          onClick={() => setActiveTabKey(String(Number(activeTabKey) - 1))}
          disabled={activeTabKey === "1"}
        >
          Précédent
        </Button>,

        <Button
          key="next"
          type="primary"
          disabled={
            activeTabKey === "1"
              ? isNextButtonDisabledTab1
              : isNextButtonDisabledTab2
          }
          onClick={() => {
            if (activeTabKey === "2") {
              if (employee) {
                setActiveTabKey("3");
                setEcheances(employee.listEcheance); // Récupérer les échéances lors de la modification
              } else {
                setActiveTabKey("3");
                handleEcheances(); // Générer les échéances lors de l'ajout
              }
            } else if (activeTabKey === "3") {
              if (employee) {
                setActiveTabKey("4"); // Aller à l'onglet "Informations supplémentaires"
              } else {
                handleSave(); // Enregistrer si c'est un ajout
              }
            } else if (activeTabKey === "4") {
              handleClose(); // Fermer pour une modification
            } else {
              setActiveTabKey(String(Number(activeTabKey) + 1));
            }
          }}
        >
          {activeTabKey === "3" && !employee
            ? "Enregistrer"
            : activeTabKey === "4"
              ? "Fermer"
              : "Suivant"}
        </Button>,
      ]}
      width={1000}
      style={{ top: 20 }}
    >
      <Form
        layout="vertical"
        form={form}
        onFieldsChange={() => {
          const allValues = form.getFieldsValue();
          // Vérification pour l'onglet Caractéristiques
          const isCompleteTab1 =
            allValues.code_type &&
            allValues.objet_pret &&
            // allValues.num_decision &&
            allValues.matrisal;
          //allValues.date_pret;
          setIsNextButtonDisabledTab1(!isCompleteTab1);

          // Vérification pour l'onglet Description
          const isCompleteTab2 =
            allValues.montant_pret &&
            allValues.duree_pret &&
            allValues.code_rub &&
            allValues.montant_ech &&
            allValues.date_prem_ech &&
            allValues.compte;
          setIsNextButtonDisabledTab2(!isCompleteTab2);

          // Calcul du montant de chaque échéance
          if (
            allValues.montant_pret &&
            allValues.duree_pret /* && allValues.periodicite */
          ) {
            const numberOfPayments =
              allValues.duree_pret; /* / allValues.periodicite */
            const montantChaqueEcheance =
              allValues.montant_pret / numberOfPayments;
            form.setFieldsValue({
              montant_ech: Math.round(montantChaqueEcheance),
            });
          }
        }}
      >
        <Tabs activeKey={activeTabKey} onChange={handleTabChange}>
          <TabPane tab="Caractéristiques" key="1">
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label="Type de Prêts"
                  name="code_type"
                  rules={[{ required: true, message: "Champ requis" }]}
                >
                  <Select
                    placeholder="Sélectionner"
                    style={{ width: "100%" }}
                    showSearch
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {typePrets.map((categ) => (
                      <Option key={categ.code} value={categ.code}>
                        {`${categ.libelle}`}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  label="Objet"
                  name="objet_pret"
                  rules={[{ required: true, message: "Champ requis" }]}
                >
                  <Select placeholder="Sélectionner" style={{ width: "100%" }}>
                    <Option value="01">Prêts au Personnel</Option>
                    <Option value="02">Autre</Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  label="Décision PV N°"
                  name="num_decision"
                // rules={[{ required: true, message: "Champ requis" }]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Salarié"
                  name="matrisal"
                  rules={[{ required: true, message: "Champ requis" }]}
                >
                  <Select
                    placeholder="- Sélectionner -"
                    style={{ width: "100%" }}
                    showSearch
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {salaries.map((salarie) => (
                      <Option key={salarie.matricule} value={salarie.matricule}>
                        {`${salarie.matricule} - ${salarie.prenoms} ${salarie.nom}`}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  label="Décision Prise le"
                  name="date_pret"
                //  rules={[{ required: true, message: "Champ requis" }]}
                >
                  <DatePicker
                    format="DD/MM/YYYY"
                    style={{ width: "100%" }}
                    disabledDate={(current) => current && current > dayjs().endOf('day')}
                  />
                </Form.Item>
              </Col>
            </Row>
          </TabPane>
          <TabPane
            tab="Description"
            key="2"
            disabled={activeTabKey < "2" && !employee}
          >
            <Row gutter={16}>
              <Col span={12}>
                <Card title="Prêts" size="small" bordered={false}>
                  <Form.Item
                    label="Montant"
                    name="montant_pret"
                    rules={[{ required: true, message: "Champ requis" }]}
                  >
                    <InputNumber
                      readOnly={!!employee}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                  <Form.Item
                    label="Durée (en mois)"
                    name="duree_pret"
                    rules={[{ required: true, message: "Champ requis" }]}
                  >
                    <InputNumber
                      readOnly={!!employee}
                      onChange={handleDuréeChange}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                  {/*  <Form.Item
                    label="Périodicité de remboursement"
                    name="periodicite"
                    rules={[{ required: true, message: "Champ requis" }]}
                  >
                    <Select
                      placeholder="Sélectionner la périodicité"
                      notFoundContent="Aucune option disponible"
                      showSearch
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {periodiciteOptions.map((option) => (
                        <Option key={option.value} value={option.value}>
                          {`${option.label}`}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item> */}

                  <Form.Item
                    name="compte"
                    label=" Compte de Remboursement"
                    rules={[{ required: true, message: "Champs requis" }]}
                  >
                    <Select
                      showSearch
                      placeholder="Sélectionnez un journal"
                      allowClear={true}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {compteGenData
                        .filter((comptegen) => comptegen.compte.length >= 6) // Filtrer les comptes avec 6 chiffres ou plus
                        .map((comptegen) => (
                          <Option
                            key={comptegen.compte}
                            value={comptegen.compte}
                          >
                            {`${comptegen.compte} - ${comptegen.intitule}`}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Card>
              </Col>
              <Col span={12}>
                <Card title="Echéance" size="small" bordered={false}>
                  <Form.Item
                    label="Montant de chaque échéance ()"
                    name="montant_ech"
                    rules={[{ required: true, message: "Champ requis" }]}
                  >
                    <Input disabled />
                  </Form.Item>
                  <Form.Item
                    label="Date de la première échéance"
                    name="date_prem_ech"
                    rules={[{ required: true, message: "Champ requis" }]}
                  >
                    <DatePicker
                      style={{ width: "100%" }}
                      format="DD/MM/YYYY"
                      disabledDate={(current) => current && current > dayjs().endOf('day')}
                    />
                  </Form.Item>
                  <Form.Item
                    label="Rubrique de remboursement"
                    name="code_rub"
                    rules={[{ required: true, message: "Champ requis" }]}
                  >
                    <Select
                      showSearch
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      placeholder="Sélectionner"
                      style={{ width: "100%" }}
                    >
                      {rubriques.map((rubrique) => (
                        <Option key={rubrique.code} value={rubrique.code}>
                          {`${rubrique.code} - ${rubrique.intitule}`}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Card>
              </Col>
            </Row>
          </TabPane>
          <TabPane
            tab="Echéancier"
            key="3"
            disabled={activeTabKey < "3" && !employee}
          >
            <Table
              showSorterTooltip={false}
              columns={columns}
              bordered
              scroll={{ x: true }}
              pagination={{
                pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
                showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
                pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
                onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
              }}
              dataSource={employee ? employee.listEcheance : echeances} // Utiliser listEcheance pour modification, echeances pour ajout
              style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
              className="custom-header-table"
            />
          </TabPane>
          {employee && (
            <TabPane tab="Information supplémentaire" key="4">
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="Montant Restant">
                    <Input
                      value={formatNumberSeparator(
                        employee ? employee.capital_du : ""
                      )}
                      readOnly
                    />
                  </Form.Item>
                  <Form.Item label="État">
                    <Input value={employee ? employee.etat : ""} readOnly />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Nombre de mois restants">
                    <Input
                      value={employee ? employee.nb_mois_restant : ""}
                      readOnly
                    />
                  </Form.Item>
                  <Form.Item label="Observation">
                    <Input
                      value={employee ? employee.observation : ""}
                      readOnly
                    />
                  </Form.Item>
                </Col>
              </Row>
            </TabPane>
          )}
        </Tabs>
      </Form>
    </Modal>
  );
};

export default NouveauPretsModal;
